import { render, staticRenderFns } from "./ApexGradientDonutChart.vue?vue&type=template&id=04759dce&scoped=true&"
import script from "./ApexGradientDonutChart.vue?vue&type=script&lang=js&"
export * from "./ApexGradientDonutChart.vue?vue&type=script&lang=js&"
import style0 from "./ApexGradientDonutChart.vue?vue&type=style&index=0&id=04759dce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04759dce",
  null
  
)

export default component.exports